"use client";

import Script from "next/script";
import { useEffect } from "react";
import { GA_ID } from "@/lib/site";

type Gtag = (...args: unknown[]) => void;

/**
 * Google Analytics 4 + pelacakan klik kontak sebagai event:
 *  - click_whatsapp  : tautan ke wa.me
 *  - click_phone     : tautan tel:
 *  - click_email     : tautan mailto:
 * Tandai ketiga event ini sebagai "Key event" di GA4 (Admin → Events) untuk menghitung konversi.
 * Perpindahan halaman (client-side) tercatat otomatis oleh Enhanced Measurement GA4.
 */
export function Analytics() {
  useEffect(() => {
    if (!GA_ID) return;
    function onClick(e: MouseEvent) {
      const link = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!link) return;
      const href = link.getAttribute("href") ?? "";
      const event = href.includes("wa.me/")
        ? "click_whatsapp"
        : href.startsWith("tel:")
          ? "click_phone"
          : href.startsWith("mailto:")
            ? "click_email"
            : null;
      if (!event) return;
      const gtag = (window as unknown as { gtag?: Gtag }).gtag;
      gtag?.("event", event, {
        link_url: href.split("?")[0],
        link_text: link.textContent?.trim().slice(0, 100) ?? "",
        page_path: window.location.pathname,
      });
    }
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  if (!GA_ID) return null;
  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} strategy="afterInteractive" />
      <Script id="ga4-init" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${GA_ID}');`}
      </Script>
    </>
  );
}
